module.exports = __webpack_public_path__ + "static/img/gift.cc0fc038.svg";